import { cva } from "styled-system/css";

/** Shared by the modal itself and the skeleton shown while its chunk downloads, so the shell
 *  does not resize when the real content arrives. */
export const modalContentStyles = cva({
  base: {
    position: "relative",
    w: "[360px]",
    bg: "background.canvas",
    borderRadius: "300",
    display: "inline-flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  variants: {
    padded: {
      true: { p: "16" },
      false: { p: "0" },
    },
  },
  defaultVariants: {
    padded: true,
  },
});
